// extracted by mini-css-extract-plugin
module.exports = {"box":"Stat-module--box--1ZjiV","onebox":"Stat-module--onebox--3NH-3","useEth":"Stat-module--useEth--38pY5","gas":"Stat-module--gas--audfM"};